// extracted by mini-css-extract-plugin
export default {"content":"style_content__2PqhT","checkbox":"style_checkbox__A0Uik","presetPermessi":"style_presetPermessi__ccenO","inputTitle":"style_inputTitle__Ywmld"};